import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-rules",
  templateUrl: "./rules.component.html",
  styleUrls: ["./rules.component.css"],
})
export class RulesComponent implements OnInit {
  rules: any = [];
  constructor(  private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService) {
  }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    const url = this.global.basePath + "common/circularlist?modelType=rules";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      console.log("🚀 ~ file: rules.component.ts ~ line 27 ~ RulesComponent ~ this.global.GetRequestUnauthorised ~ data", data)
      this.rules = data;
    });
  }

  toLink(data){
    window.open(this.global.basePathImage+data.link, "_blank");
  }
}
